import { AbstractControl, FormGroup } from '@angular/forms';
import { Column } from './models/torzsek';

export const addDays = (date: Date, days: number) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const convertBoolean = (value: 0 | 1): boolean => (value ? true : false);

export const calcSum = (
  tetelek: any[],
  skipSztorno?: boolean
): {
  netto_ar: number;
  brutto_ar: number;
  afa_ar: number;
} => {
  let netto_ar = 0;
  let brutto_ar = 0;
  let afa_ar = 0;

  tetelek.forEach((t: any) => {
    if (skipSztorno && t.statusz === -1) {
      return;
    }

    netto_ar += t.netto_ar;
    brutto_ar += t.brutto_ar;
    afa_ar += t.afa_ar;
  });

  return {
    netto_ar,
    brutto_ar,
    afa_ar,
  };
};

export const calcKintlevosegekSum = (
  tetelek: any[],
  skipSztorno?: boolean
): {
  brutto_forint: number;
  brutto_eur: number;
} => {
  let brutto_forint = 0;
  let brutto_eur = 0;

  tetelek.forEach((t: any) => {
    if (skipSztorno && t.statusz === -1) {
      return;
    }
    if(t.penznem == 'Ft') {
      brutto_forint += t.fizetendo;
    } else {
      brutto_eur += t.fizetendo;
    }
  });

  return {
    brutto_forint,
    brutto_eur
  };
};

export const calcPenztarSum = (
  tetelek: any[],
  skipSztorno?: boolean
): {
  kiadasok: number;
  bevetelek: number;
  egyenleg: number;
  penztar: number;
  euro: boolean;
} => {
  let kiadasok = 0;
  let bevetelek = 0;
  let egyenleg = 0;
  let penztar = 1;
  let euro = false;

  tetelek.forEach((t: any) => {
    if (skipSztorno && t.statusz === -1) {
      return;
    }

    if(t.bevetel_kiadas == 'bevetel') {
      bevetelek += t.osszeg;
    } else if(t.bevetel_kiadas == 'kiadas') {
      kiadasok += t.osszeg;
    }

    penztar = t.penztar_id;
    euro = t.euro;
  });

  return {
    kiadasok,
    bevetelek,
    egyenleg: bevetelek + kiadasok,
    penztar,
    euro
  };
};

export const generateId = (): string =>
  '_' + Math.random().toString(36).slice(2, 9);

export const updateObjInArray = (
  arr: any[],
  index: number,
  updated: any
): any[] =>
  arr.map((e: any, i: number) => {
    if (i === index) {
      return updated;
    }

    return e;
  });

export const updateObjPropInArray = (
  arr: any[],
  index: number,
  updated: any
): any[] =>
  arr.map((e: any, i: number) => {
    if (i === index) {
      return { ...e, ...updated };
    }

    return e;
  });

export function isRequired(formGroup: FormGroup, controlName: string): boolean {
  const control: AbstractControl = formGroup.get(controlName);

  if (!control) {
    return false;
  }

  if (control.validator) {
    const validator = control.validator({} as AbstractControl);
    if (validator && validator.required) {
      return true;
    }
  }
}

export const findByProp = (
  data: any[],
  pName: string,
  pValue: string | number | boolean
): any => {
  if (!data || !pName || !pValue) {
    return null;
  }

  return data.find((e: any) => e[pName] === pValue);
};

export const parseCim = (cim: any): string => {
  if (!cim) {
    return '-';
  } else {
    return `${cim?.iranyitoszam || ''} ${cim?.telepules || ''} ${
      cim?.kozterulet_neve || ''
    } ${cim?.kozterulet_tipusa || ''} ${cim?.hazszam || ''} ${
      cim?.epulet || ''
    } ${cim?.emelet || ''} ${cim?.ajto || ''}`;
  }
};

export const findInvalidControls = (formControls: {
  [key: string]: AbstractControl;
}): void => {
  const invalid = [];
  for (const name in formControls) {
    if (formControls[name].invalid) {
      invalid.push(name);
    }
  }

  console.log(invalid);
};

export function calculateExtraVacationDays(birthDate: Date): number {
  const birthYear = birthDate.getFullYear();
  const currentYear = new Date().getFullYear();
  const age = currentYear - birthYear;

  if (age < 25) {
    return 0;
  }

  const extraDaysTable = [
    { age: 45, days: 10 },
    { age: 43, days: 9 },
    { age: 41, days: 8 },
    { age: 39, days: 7 },
    { age: 37, days: 6 },
    { age: 35, days: 5 },
    { age: 33, days: 4 },
    { age: 31, days: 3 },
    { age: 28, days: 2 },
    { age: 25, days: 1 },
  ];

  for (const entry of extraDaysTable) {
    if (age >= entry.age) {
      return entry.days;
    }
  }

  return 0;
}

export const parseJSON = (str: string | any): any =>
  isJSONString(str) ? JSON.parse(str) : str;

export const isJSONString = (str: string): any => {
  if (Array.isArray(str)) {
    return false;
  }

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const stringifyIfJSON = (str: string | any): any => {
  if(str == null) {
    return null;
  }
  if(typeof str === 'string') {
    return str;
  } else {
    return JSON.stringify(str);
  }
}

export function parseHungarianNumber(value: string): number | null {
  if (!value) return null;
  const normalized = value.replace(/\s/g, '').replace(',', '.');
  const num = parseFloat(normalized);
  return Number.isFinite(num) ? num : null;
}

export function getDaysSince(fromDate: Date, toDate: Date): number {
    // Csak a dátum részt számoljuk (óra, perc nélkül)
    const startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    console.log('startDate', startDate)
    const endDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
    console.log('endDate', endDate)

    // Különbség milliszekundumban
    const diffInMs = endDate.getTime() - startDate.getTime();

    // Átváltás napokra -> +2nap mert kell a kezdo nap és a vég nap is
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 2;
}

export function getRemainingDaysInYear(date: Date = new Date()): number {
    const currentYear = date.getFullYear();

    // Az év utolsó napja
    const lastDayOfYear = new Date(currentYear, 11, 31);

    // Különbség milliszekundumban
    const diffInMs = lastDayOfYear.getTime() - date.getTime();

    // Milliszekundum -> nap (1 nap = 1000 * 60 * 60 * 24 ms)
    const daysRemaining = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    return daysRemaining;
}

export const calcBrutto = (netto: number, afakulcs: number): number =>
  afakulcs ? +(netto + (netto * afakulcs) / 100).toFixed(2) : +netto.toFixed(2);

export const calcNetto = (brutto: number, afakulcs: number): number =>
  afakulcs
    ? +(brutto / ((100 + afakulcs) / 100)).toFixed(2)
    : +brutto?.toFixed(2);

export const calcNettoFromAfa = (afa: number, afakulcs: number): number =>
  afakulcs ? +(afa / (afakulcs / 100)).toFixed(2) : 0.0;

export const roundToMaxTwoDecimals = (num: number): number =>
  Math.round(num * 100) / 100;

export function roundNearest5(num) {
    return Math.round(num / 5) * 5;
  }

export function roundtoN(num, n) {
  return Number(num.toFixed(n));
}

// kis segéd függvények
export const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

export const toLocalDate = (v: string | Date | null | undefined): Date | null => {
  if (!v) return null;
  if (v instanceof Date) {
    return new Date(v.getFullYear(), v.getMonth(), v.getDate());
  }
  // 'YYYY-MM-DD' vagy hasonló -> lokális nap kezdetére
  const [y, m, d] = v.split(/[T\s-:]/).map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const addDaysHelper = (d: Date, n: number) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const addHours = (date: Date, hours: number) => {
  var result = new Date(date);
  result.setHours(result.getHours() + hours);
  return result;
};

export function filterDataByYear(data: any, year: number) {
  return data;
  // return data.filter(bizonylat => {
  //   if(bizonylat.szamla_kelte) {
  //     return new Date(bizonylat.szamla_kelte).getFullYear() == year;
  //   } else if(bizonylat.bizonylat_datuma) {
  //     return new Date(bizonylat.bizonylat_datuma).getFullYear() == year;
  //   } else {
  //     if(bizonylat.teljesites_datum) {
  //       return new Date(bizonylat.teljesites_datum).getFullYear() == year;
  //     } else {
  //       return false;
  //     }
  //   }
  // });
}

export function sumByProp(array: any[], prop: string) {
  return array.reduce((a, b) => a + (b[prop] || 0), 0);
}

export function sortByTitle(nodes: any[]): any[] {
  return nodes
    .map(node => ({
      ...node,
      children: node.children ? sortByTitle(node.children) : []
    }))
    .sort((a, b) => a.data.title.localeCompare(b.data.title, 'hu'));
}

export function mapColumns(filtered: any): any {
      let result = [];

      const filters: string[] = [
        'jelszo',
        'statusz',
        'letrehozo_id',
        'letrehozva',
        'modosito_id',
        'modositva',
      ];

      filtered = filtered.filter(
        (c: Column) => !filters.includes(c.name) || c?.hidden
      );

      filtered.forEach((c: Column) => {
        // Id prop
        if (c.name.includes('_id')) {
          const noIdPropIndex = c.name.indexOf('_id');
          const noIdProp = c.name.slice(0, noIdPropIndex);

          result.push(
            { ...c, name: noIdProp, nullable: true }
          );
        }

        // Not an id prop
        else {
          result.push(c);
        }
      });
      return result;
  }


  // ✅ Defining a reusable function
  function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }

  // 👇️ format as "YYYY-MM-DD"
// You can tweak the format easily
export function formatDate(dateInput: any): any {
  const date = new Date(dateInput);
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-')
  );
}

export function sortByPropName(array: any[], prop: string) {
  return array.sort((a, b) => a[prop].localeCompare(b[prop]));
}

export function removeTrailingDot(str: string): string {
  // First, remove any trailing whitespace
  const trimmedStr = str.replace(/\s+$/, '');
  // Then, remove all trailing dots
  return trimmedStr.replace(/\.+$/, '');
}

export 
function fillDatesUntil(endDate: Date, dataArray: any[]): any[] {
  if (dataArray.length === 0) {
    throw new Error("The data array should not be empty.");
  }

  // Sort the array by 'datum'
  dataArray.sort((a, b) => new Date(a.datum).getTime() - new Date(b.datum).getTime());

  // Extract the template from the first element of the array
  const template = dataArray[0];
  let currentDate = new Date(template.datum);

  const resultArray: any[] = [dataArray[0]];

  while (currentDate < endDate) {
    currentDate.setDate(currentDate.getDate() + 1);

    // Create a new data object using the template and the new date
    const newData: any = {
      ...template,
      datum: currentDate,
      datumStr: currentDate.toISOString().split('T')[0],
      id: template.id + resultArray.length, // Or any other logic to generate a unique ID
    };

    resultArray.push(newData);
  }

  return resultArray;
}

/**
 * Converts a time (string "HH:MM" or a Date object) into a Date object,
 * setting the date part to today's date.
 *
 * @param timeInput The time as a string in "HH:MM" format (e.g., "09:30", "16:05")
 * OR a Date object from which to extract the time.
 * @returns A Date object with today's date and the specified time, or null if the input is invalid.
 */
export function convertTimeToDateToday(timeInput: string | Date): Date | null {
  let hours: number;
  let minutes: number;

  if (timeInput instanceof Date) {
    // If the input is already a Date object, extract its hours and minutes
    hours = timeInput.getHours();
    minutes = timeInput.getMinutes();
  } else if (typeof timeInput === 'string') {
    // If the input is a string, process it as before
    const timeRegex = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
    const match = timeInput.match(timeRegex);

    if (!match) {
      console.error(`Invalid time string format: "${timeInput}". Expected 'HH:MM'.`);
      return null;
    }

    hours = parseInt(match[1], 10);
    minutes = parseInt(match[2], 10);
  } else {
    // Handle cases where the input is neither a string nor a Date
    console.error(`Invalid input type. Expected string (HH:MM) or Date object, but got ${typeof timeInput}.`);
    return null;
  }

  // Get today's date (this will include the current year, month, and day)
  const today = new Date();

  // Set the extracted hours and minutes to today's date object
  today.setHours(hours);
  today.setMinutes(minutes);
  today.setSeconds(0);    // Ensure seconds are 0
  today.setMilliseconds(0); // Ensure milliseconds are 0

  return today;
}


export function formatTime(date: Date): string {
  if(!date) {
    return '00:00:00';
  }

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes}:00`;
}

export function createDateWithTime(timeString: string, date?: Date): Date {
  if(!timeString || timeString == '00:00:00') {
    return null;
  }

  const [hours, minutes] = timeString.split(':').map(Number);
  
  // If a specific date is provided, use it; otherwise, use the current date.
  const resultDate = date ? new Date(date) : new Date();
  
  // Set the time on the date
  resultDate.setHours(hours);
  resultDate.setMinutes(minutes);
  resultDate.setSeconds(0);
  resultDate.setMilliseconds(0);
  
  return resultDate;
}

export function pushUniqueBy<T>(array: T[], item: T, compare: (a: T, b: T) => boolean): T[] {
  const exists = array.some(el => compare(el, item));
  if (!exists) {
    array.push(item);
  }
  return array;
}

export function getDayDifferenceFromToday(date: Date | string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const targetDate = new Date(date);
  targetDate.setHours(0, 0, 0, 0);

  const diffInMs = targetDate.getTime() - today.getTime();
  const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays;
}

export function canEditWithinMonthWindow(selectedDate: Date | string, teszt?: string): boolean {
  const today = teszt ? new Date(teszt) : new Date();
  today.setHours(0, 0, 0, 0);

  const date = new Date(selectedDate);
  const year = date.getFullYear();
  const month = date.getMonth();

  // Start of selected month
  const monthStart = new Date(year, month, 1);
  // Start of next month
  const nextMonthStart = new Date(year, month + 1, 1);

  // Window after month start: 1st - 4th
  const monthStartWindowEnd = new Date(monthStart);
  monthStartWindowEnd.setDate(monthStart.getDate() + 3);

  // Window before next month start: 28th/29th/30th - end of month
  const nextMonthStartWindowStart = new Date(nextMonthStart);
  nextMonthStartWindowStart.setDate(nextMonthStart.getDate() - 3);

  return (
    (today >= monthStart && today <= monthStartWindowEnd) ||
    (today >= nextMonthStartWindowStart && today < nextMonthStart)
  );
}

export function canEditWithinSixDayWindow(selectedDate: Date | string, teszt?: string): boolean {
  const today = teszt ? new Date(teszt) : new Date();
  today.setHours(0, 0, 0, 0);

  const date = new Date(selectedDate);
  const year = date.getFullYear();
  const month = date.getMonth();

  // 1st day of selected month
  const monthStart = new Date(year, month, 1);
  monthStart.setHours(0, 0, 0, 0);

  // Last day of prev month
  const prevMonthEnd = new Date(year, month, 0);
  prevMonthEnd.setHours(0, 0, 0, 0);

  // Last 3 days of the month
  const prev3Days: Date[] = [];
  for (let i = 2; i >= 0; i--) {
    const day = new Date(prevMonthEnd);
    day.setDate(day.getDate() - i);
    prev3Days.push(day);
  }

  // First 3 days of the month
  const first4Days: Date[] = [];
  for (let i = 0; i < 3; i++) {
    const day = new Date(monthStart);
    day.setDate(day.getDate() + i);
    first4Days.push(day);
  }

  // Check if today matches any of the allowed days
  return [...first4Days, ...prev3Days].some(d => d.getTime() === today.getTime());
}
